import { render } from "./AdminMpRejectedValidations.vue?vue&type=template&id=08b8c7e4"
import script from "./AdminMpRejectedValidations.vue?vue&type=script&lang=js"
export * from "./AdminMpRejectedValidations.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__